import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { SessionProvider } from "context/SessionContext";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.1";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import RouteGuard from "components/RouteGuard";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <SessionProvider>
      <Switch>
        <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
        <RouteGuard
          path="/admin"
          component={AdminLayout}
          render={(props) => <AdminLayout {...props} />}
        />
        <Redirect to={{ pathname: "/admin/dashboard" }} />
      </Switch>
    </SessionProvider>
  </BrowserRouter>,
);
